import { defaultTheme } from "react-admin";

const theme = {
  ...defaultTheme,
  palette: {
    ...defaultTheme.palette,
    primary: {
      main: "#ff8e00",
    },
    secondary: {
      main: "#FFD100",
    },
    error: {
      main: "#da291c",
    },
    white: {
      main: "#fff",
    },
  },
  components: {
    ...defaultTheme.components,

    MuiTable: {},
    MuiTableHead: {
      defaultProps: {
        sx: {
          backgroundColor: "black",
          color: "white",
        },
      },
    },
    RaRichTextInput: {
      styleOverrides: {
        root: {
          "& .RaRichTextInput-editorContent .ProseMirror": {
            maxHeight: "600px",
            minHeight: "100px",
            maxWidth: "80vw",
            overflowY: "scroll",
          },
        },
      },
    },
    RaDatagrid: {
      styleOverrides: {
        root: {
          backgroundColor: "#fff",
          border: "0.5px solid #d6d1d0a3",
          borderRadius: "5px",
          "& .RaDatagrid-headerCell": {
            backgroundColor: "#333",
            color: "#fff",
            fontWeight: 700,
            fontSize: 15,
            paddingRight: "5px",
            paddingLeft: "10px",
          },
          "& .MuiTableSortLabel-root.Mui-active": {
            color: "#fff",
          },
          "& .MuiTableSortLabel-root.Mui-active .MuiTableSortLabel-icon": {
            color: "#fff",
          },
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        variant: "outlined",
      },
    },
    MuiFormControl: {
      defaultProps: {
        variant: "outlined",
      },
    },
  },
};

export default theme;
